import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import Actions from "../../../Actions";
import { ActionsAdAssistant } from "../../../Actions/ActionsAdAssistant/ActionsAdAssistant";
import { mapCampaignData } from "../utils";

export const useSaveCampaign = (campaignId) => {
  const { t } = useTranslation();

  const saveCampaign = useCallback(
    (data) => {
      const newCampaignData = { ...data };

      return new Promise((resolve, reject) => {
        // Set up listeners for success and failure
        const saveSuccessfully = ActionsAdAssistant.updateAssistantCampaign.completed.listen(() => {
          Actions.addNotification(t("Saved correctly"));
          // Refresh store data
          ActionsAdAssistant.getAssistantCampaign(campaignId);
          saveSuccessfully();
          resolve();
        });

        const saveError = ActionsAdAssistant.updateAssistantCampaign.failed.listen((error) => {
          Actions.addNotification(t("Save failed"), "error");
          saveError(); // Cleanup listener
          reject(error);
        });

        const mappedData = mapCampaignData(newCampaignData);

        // Trigger the save action
        ActionsAdAssistant.updateAssistantCampaign(mappedData, campaignId);
      });
    },
    [campaignId, t]
  );

  return saveCampaign;
};
